var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestPause({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 13.6668C2.98467 13.6668 0 10.6822 0 7.00016C0 3.31816 2.98467 0.333496 6.66667 0.333496C10.3487 0.333496 13.3333 3.31816 13.3333 7.00016C13.3333 10.6822 10.3487 13.6668 6.66667 13.6668ZM4.66667 5.00016V9.00016H6V5.00016H4.66667ZM7.33333 5.00016V9.00016H8.66667V5.00016H7.33333Z",
    fill: "#FF4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestPause);
export default __webpack_public_path__ + "static/media/request-pause.d5a01b6454bdb53adfa671947b466f04.svg";
export { ForwardRef as ReactComponent };